export default {
    GetDiscount(state) {
        return state.discount
    },
    GetDiscounts(state) {
        return state.discounts
    }
};